import React, { type FC, forwardRef } from "react";
import { Button } from "@edreamsodigeo/prisma-design-system";

import type { UserVerificationModalButtonProps } from "./contract";

const UserVerificationModalButton: FC<UserVerificationModalButtonProps> =
  forwardRef((props, ref) => {
    const { onClick, children } = props;
    return (
      <Button type="secondary" onClick={onClick} ref={ref}>
        {children}
      </Button>
    );
  });

export default UserVerificationModalButton;
